import React from 'react';
import ColaPacientes from '../components/ColaPaciente';
import PantallaCargaMedica from '../components/common/PantallaCargaMedica';
import { useDashboardData } from '../hooks/useDashboardData';

export default function Dashboard() {
    // 1. CONSUMO DE LÓGICA DE NEGOCIO (Aislada por SRP)
    const {
        citasFiltradas,
        citasAgrupadasPorMedico,
        metricas,
        loading,
        cargarDatos,
        user,
        tieneAccesoGlobal
    } = useDashboardData();

    // 2. ESTADO DE CARGA (UI) — pantalla contextual de recopilación de datos
    if (loading) {
        return (
            <div className="min-h-screen p-4 md:p-8 bg-slate-50/50">
                <PantallaCargaMedica variante="dashboard" />
            </div>
        );
    }

    // 3. RENDERIZADO DEL ORQUESTADOR
    return (
        <div className="min-h-screen p-4 md:p-8 bg-slate-50/50 space-y-8 animate-fade-in">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
                <div>
                    <h1 className="text-3xl font-black text-slate-900 tracking-tight">
                        {tieneAccesoGlobal ? 'Sala de espera' : `¡Hola, ${user?.nombre || ''}!`}
                    </h1>
                    <p className="text-sm font-semibold text-slate-500 mt-1">
                        {tieneAccesoGlobal ? 'Quién está citado hoy, quién espera y quién está en consulta, en tiempo real.' : 'Tus citas de hoy y los pacientes que te esperan.'}
                    </p>
                </div>
            </div>

            {/* Módulo de KPIs Delegado */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                <MetricaCard titulo="Citas Programadas" valor={metricas.total} icon="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2-2v12a2 2 0 002 2z" color="slate" />
                <MetricaCard titulo="Atendidos Hoy" valor={metricas.completadas} icon="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" color="emerald" />
                <MetricaCard titulo="En Espera / Pendientes" valor={metricas.pendientes} icon="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" color="amber" />
            </div>

            <div className="w-full">
                {tieneAccesoGlobal ? (
                    citasAgrupadasPorMedico.length > 0 ? (
                        <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 items-start">
                            {citasAgrupadasPorMedico.map(grupo => (
                                <div key={grupo.id} className="bg-white border border-slate-200 rounded-[2rem] p-6 shadow-sm flex flex-col gap-4">
                                    <div className="flex items-center gap-3 border-b border-slate-100 pb-4">
                                        <div className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center font-bold text-lg shrink-0">
                                            {grupo.nombre.charAt(0)}
                                        </div>
                                        <div>
                                            <h2 className="text-lg font-black text-slate-800 leading-tight">{grupo.nombre}</h2>
                                            <p className="text-xs font-semibold text-slate-400">Estado del box en tiempo real</p>
                                        </div>
                                    </div>
                                    <div className="flex-1">
                                        <ColaPacientes citas={grupo.citas} idMedicoLogueado={grupo.id} fetchAgendaDiaria={cargarDatos} esVistaMultiSala={true} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="p-12 text-center bg-white border border-slate-200 rounded-3xl shadow-sm">
                            <h3 className="text-xl font-bold text-slate-500">No hay citas programadas para hoy en ninguna agenda.</h3>
                        </div>
                    )
                ) : (
                    <ColaPacientes citas={citasFiltradas} idMedicoLogueado={user?.id} fetchAgendaDiaria={cargarDatos} esVistaMultiSala={false} />
                )}
            </div>
        </div>
    );
}

// 🧩 Sub-Componente de Presentación Pura (SRP aplicado a la vista)
function MetricaCard({ titulo, valor, icon, color }) {
    const colorStyles = {
        slate: "bg-slate-100 text-slate-700",
        emerald: "bg-emerald-50 text-emerald-600 border border-emerald-100",
        amber: "bg-amber-50 text-amber-600 border border-amber-100"
    };

    return (
        <div className="flex items-center gap-4 p-6 bg-white border border-slate-200/80 rounded-3xl shadow-sm">
            <div className={`flex items-center justify-center w-12 h-12 rounded-2xl shrink-0 ${colorStyles[color]}`}>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d={icon}></path>
                </svg>
            </div>
            <div>
                <p className="text-[10px] font-black text-slate-400 tracking-widest uppercase">{titulo}</p>
                <h3 className="text-2xl font-black text-slate-900 mt-0.5">{valor}</h3>
            </div>
        </div>
    );
}